import React, { useEffect, useState } from "react";
import {
  Typography,
  Card,
  CardContent,
  Box,
  IconButton,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import TextContainerField from "../../../components/TextContainerField";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import { fetchDataById } from "../../../services";
import { ViewDateFormat } from "../../Utils/ViewDateFormat";
import { useSnackbar } from "../../../context/popup";
import { setCircleLoading } from "../../../components/Loading";

const ViewMotorBodyStyle = () => {
  const navigate = useNavigate();
  const params = useParams();
  const showSnackbar = useSnackbar();
  const [bodyStyleData, setBodyStyleData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const paramId = params.id;

      if (paramId) {
        setCircleLoading(true);
        try {
          await fetchDataById(`/reference/motor/bodystyle/${paramId}`).then(
            (res) => {
              setBodyStyleData((prevData) => ({
                ...prevData,
                ...res?.data,
              }));
            }
          );
        } catch (error) {
          setBodyStyleData(null);
          console.error("Error Fetching Data",error);
          showSnackbar(error?.response?.data?.message || "Network Error", "error");
        } finally {
          setCircleLoading(false);
        }
      }
    };

    fetchData();
  }, [params.id]);

  return (
    <DashboardLayout>
      <Box
        sx={{
          padding: { xs: 2, md: 2 },
          bgcolor: "#f9f9f9",
          minHeight: "100vh",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="left"
          spacing={1}
          mb={2}
        >
          <IconButton onClick={() => navigate("/motor-master/motor-bodyStyle")}>
            <ArrowBack />
          </IconButton>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
            Motor Body Style Information
          </Typography>
        </Stack>

        {bodyStyleData ? (
          <Grid container spacing={3} sx={{ mx: { xs: 0, md: 2 } }}>
            <Grid xs={12} sm={6} md={4} sx={{ width: "100%" }}>
              <Card sx={{ boxShadow: 3, borderRadius: 2, bgcolor: "white" }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 1, fontWeight: "600" }}>
                    {bodyStyleData?.name}
                  </Typography>
                  <TextContainerField
                    label="Motor Body Style ID"
                    value={bodyStyleData?.id}
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField
                    label="Motor Body Type ID"
                    value={bodyStyleData?.motorBodyTypeId}
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField
                    label="Motor Body Type"
                    value={bodyStyleData?.bodyType?.name}
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField
                    label="Status"
                    value={bodyStyleData?.active ? "Active" : "Inactive"}
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField
                    label="Created At"
                    value={ViewDateFormat(bodyStyleData?.createdAt)}
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField
                    label="Updated At"
                    value={ViewDateFormat(bodyStyleData?.updatedAt)}
                    labelStyle={{ fontWeight: "500" }}
                  />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        ) : (
          <Box>
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                textAlign: "center",
                fontWeight: "bold",
                color: "red",
                fontFamily: "cursive",
              }}
            >
              No Motor Body Style Data Found
            </Typography>
          </Box>
        )}
      </Box>
    </DashboardLayout>
  );
};

export default ViewMotorBodyStyle;
